import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EnterpriseSupportSvg = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 21 22",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#enterprise-support-clip)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.88796 16.2848H3.23996C2.55252 16.2848 1.89323 16.0117 1.40713 15.5256C0.921035 15.0395 0.647949 14.3802 0.647949 13.6928V11.1008C0.647949 10.4134 0.921035 9.75408 1.40713 9.26797C1.89323 8.78187 2.55252 8.50879 3.23996 8.50879H3.88796C4.05982 8.50879 4.22465 8.57706 4.34617 8.69858C4.46769 8.82011 4.53596 8.98493 4.53596 9.15679V15.6368C4.53596 15.8087 4.46769 15.9735 4.34617 16.095C4.22465 16.2166 4.05982 16.2848 3.88796 16.2848Z",
                        stroke: "#676879",
                        strokeWidth: "0.972004",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.4962 16.2848H16.8482C16.6763 16.2848 16.5115 16.2166 16.39 16.095C16.2685 15.9735 16.2002 15.8087 16.2002 15.6368V9.15679C16.2002 8.98493 16.2685 8.82011 16.39 8.69858C16.5115 8.57706 16.6763 8.50879 16.8482 8.50879H17.4962C18.1836 8.50879 18.8429 8.78187 19.329 9.26797C19.8151 9.75408 20.0882 10.4134 20.0882 11.1008V13.6928C20.0882 14.3802 19.8151 15.0395 19.329 15.5256C18.8429 16.0117 18.1836 16.2848 17.4962 16.2848Z",
                        stroke: "#676879",
                        strokeWidth: "0.972004",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.24023 8.50986C3.24023 6.61939 3.99122 4.80635 5.32799 3.46959C6.66475 2.13282 8.47779 1.38184 10.3683 1.38184C12.2587 1.38184 14.0718 2.13282 15.4085 3.46959C16.7453 4.80635 17.4963 6.61939 17.4963 8.50986",
                        stroke: "#676879",
                        strokeWidth: "0.972004",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.96 19.5261H14.904C15.5914 19.5261 16.2507 19.253 16.7368 18.7669C17.2229 18.2809 17.496 17.6215 17.496 16.9341V16.2861",
                        stroke: "#676879",
                        strokeWidth: "0.972004",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.6643 20.8215H10.3683C10.0246 20.8215 9.69487 20.685 9.45182 20.4419C9.20878 20.1989 9.07227 19.8692 9.07227 19.5255C9.07227 19.1818 9.20878 18.8521 9.45182 18.609C9.69487 18.366 10.0246 18.2295 10.3683 18.2295H11.6643C12.008 18.2295 12.3377 18.366 12.5807 18.609C12.8238 18.8521 12.9603 19.1818 12.9603 19.5255C12.9603 19.8692 12.8238 20.1989 12.5807 20.4419C12.3377 20.685 12.008 20.8215 11.6643 20.8215Z",
                        stroke: "#676879",
                        strokeWidth: "0.972004",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.77588 7.86202C7.77597 7.38685 7.90668 6.92084 8.15372 6.51493C8.40077 6.10902 8.75462 5.77883 9.17669 5.56045C9.59867 5.34207 10.0727 5.2439 10.5467 5.27668C11.0207 5.30946 11.4767 5.47191 11.8646 5.7463C12.2525 6.02068 12.5576 6.39642 12.7464 6.83247C12.9353 7.26851 13.0006 7.74808 12.9353 8.21875C12.87 8.68941 12.6766 9.13308 12.3762 9.50126C12.0758 9.86942 11.6799 10.1479 11.2319 10.3063C10.9791 10.3957 10.7602 10.5612 10.6055 10.7802C10.4507 10.9992 10.3677 11.2607 10.3679 11.5288V11.75",
                        stroke: "#676879",
                        strokeWidth: "0.972004",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.3679 14.9888C10.189 14.9888 10.0439 14.8438 10.0439 14.6648C10.0439 14.4859 10.189 14.3408 10.3679 14.3408",
                        stroke: "#676879",
                        strokeWidth: "0.972004"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.3682 14.9888C10.5471 14.9888 10.6922 14.8438 10.6922 14.6648C10.6922 14.4859 10.5471 14.3408 10.3682 14.3408",
                        stroke: "#676879",
                        strokeWidth: "0.972004"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "enterprise-support-clip",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "21",
                        height: "22",
                        fill: "white"
                    })
                })
            })
        ]
    });
export default EnterpriseSupportSvg;
